'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _Base = require('../Base/Base');

var _Base2 = _interopRequireDefault(_Base);

require('./Grid.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Grid = function (_Component) {
  _inherits(Grid, _Component);

  function Grid() {
    _classCallCheck(this, Grid);

    return _possibleConstructorReturn(this, (Grid.__proto__ || Object.getPrototypeOf(Grid)).apply(this, arguments));
  }

  _createClass(Grid, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          direction = _props.direction,
          fill = _props.fill,
          fit = _props.fit,
          full = _props.full,
          gutters = _props.gutters,
          horizontalAlign = _props.horizontalAlign,
          _props$horizontalGutt = _props.horizontalGutters,
          horizontalGutters = _props$horizontalGutt === undefined ? gutters : _props$horizontalGutt,
          none = _props.none,
          responsive = _props.responsive,
          shrink = _props.shrink,
          verticalAlign = _props.verticalAlign,
          _props$verticalGutter = _props.verticalGutters,
          verticalGutters = _props$verticalGutter === undefined ? gutters : _props$verticalGutter,
          wrap = _props.wrap,
          rest = _objectWithoutProperties(_props, ['children', 'className', 'direction', 'fill', 'fit', 'full', 'gutters', 'horizontalAlign', 'horizontalGutters', 'none', 'responsive', 'shrink', 'verticalAlign', 'verticalGutters', 'wrap']);

      var classes = (0, _classnames3.default)('ax-grid', (_classnames = {
        'ax-grid--responsive': responsive,
        'ax-grid--columns': direction === 'column'
      }, _defineProperty(_classnames, 'ax-grid--gutters-horizontal--' + horizontalGutters, typeof horizontalGutters === 'string'), _defineProperty(_classnames, 'ax-grid--gutters-vertical--' + verticalGutters, typeof verticalGutters === 'string'), _defineProperty(_classnames, 'ax-grid--fill', fill === true), _defineProperty(_classnames, 'ax-grid--fill--' + fill, fill && fill !== true), _defineProperty(_classnames, 'ax-grid--fit', fit === true), _defineProperty(_classnames, 'ax-grid--fit--' + fit, fit && fit !== true), _defineProperty(_classnames, 'ax-grid--full', full === true), _defineProperty(_classnames, 'ax-grid--full--' + full, full && full !== true), _defineProperty(_classnames, 'ax-grid--none', none === true), _defineProperty(_classnames, 'ax-grid--none--' + none, none && none !== true), _defineProperty(_classnames, 'ax-grid--shrink', shrink === true), _defineProperty(_classnames, 'ax-grid--shrink--' + shrink, shrink && shrink !== true), _defineProperty(_classnames, 'ax-grid--vertical-' + verticalAlign, verticalAlign), _defineProperty(_classnames, 'ax-grid--horizontal-' + horizontalAlign, horizontalAlign), _defineProperty(_classnames, 'ax-grid--wrap', wrap === true), _classnames), className);

      return _react2.default.createElement(
        _Base2.default,
        _extends({ space: 'x6' }, rest, { className: 'ax-grid__container' }),
        _react2.default.createElement(
          'div',
          { className: classes },
          children
        )
      );
    }
  }]);

  return Grid;
}(_react.Component);

Grid.propTypes = {
  /** <GridCells>. */
  children: _propTypes2.default.node,
  /** Class name to be appended to the element */
  className: _propTypes2.default.string,
  /*
  * Controls the direction of the grid cells
  */
  direction: _propTypes2.default.oneOf(['row', 'column']),
  /**
   * Applies fill styling for all GridCell children.
   * See GridCell for fill explanation
   */
  fill: _propTypes2.default.oneOf([true, 'small', 'medium', 'large']),
  /**
   * Applies fit styling for all GridCell children.
   * See GridCell for fit explanation
   */
  fit: _propTypes2.default.oneOf([true, 'small', 'medium', 'large']),
  /**
   * Applies full styling for all GridCell children.
   * See GridCell for full explanation
   */
  full: _propTypes2.default.oneOf([true, 'small', 'medium', 'large']),
  /** Controls the horizontal and vertical spacing between cells */
  gutters: _propTypes2.default.oneOf([false, 'tiny', 'small', 'medium', 'large']),
  /** Controls the horizontal alignment of all cells */
  horizontalAlign: _propTypes2.default.oneOf(['start', 'middle', 'end', 'around', 'between']),
  /** Controls the horizontal spacing between cells */
  horizontalGutters: _propTypes2.default.oneOf([false, 'tiny', 'small', 'medium', 'large']),
  /**
   * Applies none styling for all GridCell children.
   * See GridCell for none explanation
   */
  none: _propTypes2.default.oneOf([true, 'small', 'medium', 'large']),
  /**
   * Default behaviour of cells is to resize to 100% of the grids space when
   * on smaller screen sizes. This allows this behaviour to be suppressed.
   */
  responsive: _propTypes2.default.bool,
  /**
   * Applies shrink styling for all GridCell children.
   * See GridCell for shrink explanation
   */
  shrink: _propTypes2.default.oneOf([true, 'small', 'medium', 'large']),
  /** Controls the vertical alignment of all cells */
  verticalAlign: _propTypes2.default.oneOf(['start', 'middle', 'end']),
  /** Controls the vertical spacing between cells */
  verticalGutters: _propTypes2.default.oneOf([false, 'tiny', 'small', 'medium', 'large']),
  /** Allows cells to drop to a new line when they require more space */
  wrap: _propTypes2.default.bool
};
Grid.defaultProps = {
  direction: 'row',
  responsive: true,
  gutters: 'medium',
  wrap: true
};
exports.default = Grid;